import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Equipo',
    href: '#equipo'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }];
  const whatsappUrl = 'https://wa.me/5492995192151?text=%C2%A1Hola!%20Vi%20la%20web%20y%20quiero%20reservar%20un%20turno';
  return <>
      <motion.nav initial={{
      y: -100
    }} animate={{
      y: 0
    }} transition={{
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }} className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${isScrolled ? 'bg-cream/95 backdrop-blur-sm border-b border-sand/30 py-4' : 'bg-transparent py-6'}`} data-id="element-61">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-62">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group" data-id="element-63">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={`transition-colors duration-300 ${isScrolled ? 'text-olive' : 'text-cream'}`} data-id="element-64">
              <path d="M12 2C12 2 8 6 8 12C8 18 12 22 12 22C12 22 16 18 16 12C16 6 12 2 12 2Z" fill="currentColor" opacity="0.8" data-id="element-65" />
              <circle cx="9" cy="8" r="1.5" fill="currentColor" data-id="element-66" />
              <circle cx="15" cy="8" r="1.5" fill="currentColor" data-id="element-67" />
              <circle cx="12" cy="6" r="1.5" fill="currentColor" data-id="element-68" />
            </svg>
            <span className={`font-serif text-xl tracking-wider transition-colors duration-300 ${isScrolled ? 'text-matte' : 'text-cream'}`} data-id="element-69">
              TERRA VET
            </span>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8" data-id="element-70">
            <div className="flex items-center gap-8" data-id="element-71">
              {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm tracking-wide transition-colors duration-300 hover:opacity-70 ${isScrolled ? 'text-matte' : 'text-cream'}`} data-id="element-72">
                  {link.name}
                </a>)}
            </div>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="bg-olive hover:bg-olive-light text-cream px-6 py-3 text-xs tracking-widest uppercase transition-colors duration-300" data-id="element-73">
              Reservar Turno
            </a>
          </div>

          {/* Mobile Menu Toggle */}
          <button className={`md:hidden p-2 transition-colors duration-300 ${isScrolled ? 'text-matte' : 'text-cream'}`} onClick={() => setIsMobileMenuOpen(true)} aria-label="Open menu" data-id="element-74">
            <Menu size={24} strokeWidth={1.5} data-id="element-75" />
          </button>
        </div>
      </motion.nav>

      {/* Mobile Drawer */}
      <AnimatePresence data-id="element-76">
        {isMobileMenuOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.3
        }} className="fixed inset-0 bg-matte/20 backdrop-blur-sm z-[60] md:hidden" onClick={() => setIsMobileMenuOpen(false)} data-id="element-77" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          duration: 0.4,
          ease: [0.22, 1, 0.36, 1]
        }} className="fixed top-0 right-0 bottom-0 w-4/5 max-w-sm bg-cream z-[70] p-8 flex flex-col md:hidden shadow-2xl" data-id="element-78">
              <div className="flex justify-end mb-12" data-id="element-79">
                <button onClick={() => setIsMobileMenuOpen(false)} className="p-2 text-matte hover:text-terracotta transition-colors" aria-label="Close menu" data-id="element-80">
                  <X size={24} strokeWidth={1.5} data-id="element-81" />
                </button>
              </div>

              <div className="flex flex-col gap-8" data-id="element-82">
                {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="font-serif text-3xl text-matte hover:text-terracotta transition-colors" data-id="element-83">
                    {link.name}
                  </a>)}
              </div>

              <div className="mt-auto pt-12 border-t border-sand/30" data-id="element-84">
                <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="flex justify-center bg-olive text-cream px-6 py-4 text-sm tracking-widest uppercase w-full" data-id="element-85">
                  Reservar Turno
                </a>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </>;
}